import api from './axios';

/**
 * Bug Report API Service
 * Handles bug report related API calls
 */

/**
 * Report a new bug with screenshot
 * @param {Object} bugData - Bug report data
 * @param {string} bugData.title - Bug title
 * @param {string} bugData.description - Bug description
 * @param {string} bugData.url - Current page URL
 * @param {File} bugData.screenshot - Screenshot file
 * @returns {Promise} API response with bug details
 */
export const reportBug = async ({ title, description, url, screenshot }) => {
  const formData = new FormData();
  formData.append('Title', title);
  formData.append('Description', description);
  formData.append('Url', url);
  
  if (screenshot) {
    formData.append('Attachments', screenshot);
  }

  const response = await api.post('/api/Bug', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  
  return response.data;
};

export const generateBugDescription = async ({ title }) => {
  const response = await api.post('/api/Bug/generate-description', {
    title: title
  });
  
  return response.data;
};